import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Hexagon = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.WHITE
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 22 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M20.5 16.1644V7.49778C20.4996 7.11783 20.3993 6.74466 20.2092 6.4157C20.019 6.08675 19.7457 5.81359 19.4167 5.62361L11.8333 1.29028C11.504 1.10011 11.1303 1 10.75 1C10.3697 1 9.99604 1.10011 9.66667 1.29028L2.08333 5.62361C1.75428 5.81359 1.48098 6.08675 1.29083 6.4157C1.10069 6.74466 1.00039 7.11783 1 7.49778V16.1644C1.00039 16.5444 1.10069 16.9176 1.29083 17.2465C1.48098 17.5755 1.75428 17.8486 2.08333 18.0386L9.66667 22.3719C9.99604 22.5621 10.3697 22.6622 10.75 22.6622C11.1303 22.6622 11.504 22.5621 11.8333 22.3719L19.4167 18.0386C19.7457 17.8486 20.019 17.5755 20.2092 17.2465C20.3993 16.9176 20.4996 16.5444 20.5 16.1644Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.75 16.1644C13.1432 16.1644 15.0833 14.2243 15.0833 11.8311C15.0833 9.43788 13.1432 7.49778 10.75 7.49778C8.35677 7.49778 6.41667 9.43788 6.41667 11.8311C6.41667 14.2243 8.35677 16.1644 10.75 16.1644Z'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Hexagon;
